module.exports = __webpack_public_path__ + "8565207e1accce8300cb270466e0d0ff.svg";